<template>
  <div>
    <div class="animate__animated animate__fadeIn">
      <h1 class="h3 mb-3 text-gray-800">{{ $t("Enviar SMS") }}</h1>

      <div class="card mb-0 shadow">
        <div class="card-body">
          <form @submit.prevent="submit" ref="addItem">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <b-form-input
                    v-model="item.phone_number"
                    placeholder="+5579999279002"
                    v-mask="'+55###########'"
                  ></b-form-input>
                </div>
                <div class="col-md-12 mt-3">
                  <b-form-textarea
                    id="textarea"
                    v-model="item.mensagem"
                    placeholder="Digite sua mensagem..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="row pt-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <a class="btn btn-default" @click="$emit('voltar')">
                    <i class="mdi mdi-arrow-left" />
                  </a>
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      item: {
        phone_number: "",
        mensagem: "",
      },
    };
  },
  methods: {
    submit() {
      axios.post("api/dashboard/admin/sms/send", this.item).then((response) => {
        this.$snack.success({
          button: false,
          text: "Mensagem enviada!",
        });
      });
    },
  },
};
</script>
<style lang="css">
.list-group-item-action {
  cursor: pointer;
}
</style>
